module.exports = __webpack_public_path__ + "img/1490926457.310c35b4.jpg";